import { DEFAULT_RECT, filtersId, HEADER_FIXED_DISTANCE } from './constants';
import { DimsProps, RectProps } from './types';


export const handleStyle = (position: string, top: string, bottom: string) => {
    const elem = document.querySelector(filtersId);
    if (elem && elem.style) {
      elem.style.position = position;
      elem.style.bottom = bottom;
      elem.style.top = top;
    }
  };

  export const getStyle = (type: string, dim: DimsProps) => {
    switch (type) {
      case 'top-fixed':
        return handleStyle('fixed', (dim.headerHeight + HEADER_FIXED_DISTANCE) + 'px', 'auto');
      case 'bottom-fixed':
        return handleStyle('fixed', 'auto', '20px');
      case 'hang-state':
        return handleStyle('relative', dim.staticTop + 'px', 'auto');
      case 'footer-show':
        return handleStyle('absolute', 'auto', '20px');
      case 'static-state':
        return handleStyle('static', 'auto', 'auto');
      default:
        return handleStyle('static', 'auto', 'auto');
    }
  };

  export const getCordinate = (ele: string) => {
    const elem = document.querySelector(ele);
    let box: RectProps = elem?.getBoundingClientRect() || DEFAULT_RECT;
    let body = document.body;
    let docEl = document.documentElement;
    let scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    let clientTop = docEl.clientTop || body.clientTop || 0;
    let top = box?.top + scrollTop - clientTop;
    return { top: Math.round(top), topMargin : box.top };
  };

  export function isInViewport(ele: string, top: number = 0) {
    const element = document.querySelector(ele);
    const rect: RectProps = element?.getBoundingClientRect() || DEFAULT_RECT;
    return (
        rect.top >= top &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

export const isHeightInViewPort = (id: string, height: number = 0) => {
  const viewPortHeight = (window?.innerHeight - height);
  const eleHeight = ((document.querySelector(id)?.clientHeight) || 0);
  return ((viewPortHeight - eleHeight) > 0);
};
